import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, memo, forwardRef } from 'react';
import { PasswordInput as PasswordInputEl, PasswordInputWrapper, TogglePasswordButton } from './PasswordInput.styles';
import { getTexts } from '../../lib/contentful/defaultTexts';
var PasswordInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var _getTexts = getTexts(),
    _getTexts$signup = _getTexts.signup,
    hide = _getTexts$signup.passwordInputHideText,
    show = _getTexts$signup.passwordInputShowText;
  return /*#__PURE__*/React.createElement(PasswordInputWrapper, null, /*#__PURE__*/React.createElement(PasswordInputEl, _extends({
    ref: ref
  }, props, {
    type: showPassword && 'text' || 'password'
  })), /*#__PURE__*/React.createElement(TogglePasswordButton, {
    onClick: toggleVisibility,
    size: "small",
    "data-test": "toggle_password_button"
  }, showPassword ? hide : show));
  function toggleVisibility() {
    setShowPassword(!showPassword);
  }
});
PasswordInput.displayName = 'PasswordInput';
export default /*#__PURE__*/memo(PasswordInput);